import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IMG } from "../../../../assets";
import { motion, useInView, useAnimation } from "framer-motion";
import "./Doctors.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function Doctors() {
  const [expandedCard, setExpandedCard] = useState(null);

  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { triggerOnce: false, threshold: 0.1 });

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [isInView, controls]);
  const array = [
    {
      id: 1,
      // img: "https://media.istockphoto.com/id/1219598026/photo/cheerful-young-doctor-in-white-coat-smiling-while-looking-at-screen-of-his-phone-using.jpg?s=612x612&w=0&k=20&c=cVDxO4BULzau-fNoAQ3GpuqamDa1BZLm951awdJYfFI=",
      img: IMG.DOC1,
      name: "DR. SALEM AL-QABANDI",
      designation: "SENIOR CONSULTANT",
      speciality: "PERIODONTICS & GENERAL DENTISTRY",
      education: [
        {
          education1:
            "Doctor of Medical Sciences and Certificate in Orthodontics from Harvard University School of Dental Medicine in Boston, MA",
          education2:
            "Doctor of Dental Medicine (D.M.D) from Boston University Goldman School of Dental Medicine, graduating Magna Cum Laude",
          education3:
            "Bachelor of Arts in Predental Sciences with a minor in Mathematics from Boston University College of Arts and Sciences",
          education4: "",
          education5: "",
        },
      ],
      memberships: [
        "American Association of Orthodontics",
        "College of Diplomates of the American Board of Orthodontics",
        "Harvard Society for the Advancement of Orthodontics",
        "Kuwait Orthodontic Society",
        "American Student Dental Association",
        "American Dental Association",
      ],
    },
    {
      id: 2,
      img: IMG.DOC2,
      name: "Dr. MOHAMMAD AL NOURI",
      designation: "SENIOR CONSULTANT",
      speciality: "PERIODONTICS & GENERAL DENTISTRY",
      education: [
        {
          education1:
            "Bachelor's of Dental Medicine (B.D.M.) with Honors: Graduation with Distinction at Kuwait University, Faculty of Dentistry",
          education2:
            "Bachelor's of Medical Science degree (B.Med.Sc.) with Honors: Graduation with Distinction, also from Kuwait University, Faculty of Dentistry",
          education3:
            "Pediatric Dentistry at the University of Maryland–College of Dentistry.",
          education4: "Completed the Internationally-Trained Dentists program.",
          education5:
            "Pediatric Dentistry Residency and earned a Master’s in Oral Sciences at the University of Illinois at Chicago – College of Dentistry.",
        },
      ],
      memberships: [
        "Illinois Society for Pediatric Dentists (ISPD)",
        "American Academy of Pediatric Dentistry (AAPD)",
        "Kuwait Dental Association",
        "The International Association for Dental Research (IADR)",
      ],
    },
    {
      id: 3,
      // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
      img: IMG.DOC3,
      name: "DR. AHMAD AL-AWADHI",
      designation: "SENIOR CONSULTANT",
      speciality: "PERIODONTICS & GENERAL DENTISTRY",
      education: [
        {
          education1:
            "Advanced training in Prosthodontics through the Specialty Program at the Herman Ostrow School of Dentistry at USC",
          education2:
            "Master’s of Academic Medicine earned at Kerk School of Medicine at USC",
          education3:
            "Dental License in California was obtained through the Western Regional Board Examination (WREBs)",
          education4: "DEA and NPI certifications",
          education5: "",
        },
      ],
      memberships: [
        "ADA member",
        "Member in American College of Prosthodontics (ACP) ",
        "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
        "Member of Dent-Cal program in the State of California",
      ],
    },
    {
      id: 4,
      // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
      img: IMG.DOC4,
      name: "DR. SHAHAD AL SHEMALI",
      designation: "SENIOR CONSULTANT",
      speciality: "PERIODONTICS & GENERAL DENTISTRY",
      education: [
        {
          education1:
            "Advanced training in Prosthodontics through the Specialty Program at the Herman Ostrow School of Dentistry at USC",
          education2:
            "Master’s of Academic Medicine earned at Kerk School of Medicine at USC",
          education3:
            "Dental License in California was obtained through the Western Regional Board Examination (WREBs)",
          education4: "DEA and NPI certifications",
          education5: "",
        },
      ],
      memberships: [
        "ADA member",
        "Member in American College of Prosthodontics (ACP) ",
        "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
        "Member of Dent-Cal program in the State of California",
      ],
    },
    {
      id: 5,
      // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
      img: IMG.DOC5,
      name: "DR. AISHA TIFOUNI",
      designation: "SENIOR CONSULTANT",
      speciality: "PERIODONTICS & GENERAL DENTISTRY",
      education: [
        {
          education1:
            "Advanced training in Prosthodontics through the Specialty Program at the Herman Ostrow School of Dentistry at USC",
          education2:
            "Master’s of Academic Medicine earned at Kerk School of Medicine at USC",
          education3:
            "Dental License in California was obtained through the Western Regional Board Examination (WREBs)",
          education4: "DEA and NPI certifications",
          education5: "",
        },
      ],
      memberships: [
        "ADA member",
        "Member in American College of Prosthodontics (ACP) ",
        "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
        "Member of Dent-Cal program in the State of California",
      ],
    },
  ];

  const toggleExpand = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div
      ref={ref}
      className="h-auto flex flex-col justify-center items-center md:pt-20 md:pb-35 pt-[2%] pb-[4%] px-5"
    >
      <div className=" max-w-screen-2xl w-full h-full bg-blur rounded-[12px] md:rounded-[50px] p-9 sm:p-15">
        <motion.p
          initial="hidden"
          animate={controls}
          variants={{
            visible: { opacity: 1, y: 0, transition: { duration: 1.25 } },
            hidden: { opacity: 0, y: -100 },
          }}
          className="w-full text-center lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-secondary leading-9 md:leading-0"
        >
          Know our <span className="font-bold">Doctors</span>
        </motion.p>
        <div className="w-full mt-[10%] md:mt-[4%]">
          <Swiper
            style={{
              "--swiper-navigation-color": "#7B899C",
            }}
            spaceBetween={20}
            loop={true}
            speed={1000}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={false}
            breakpoints={{
              374: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            grabCursor={true}
            modules={[Autoplay, Pagination]}
            className="mySwiper "
          >
            {array.map((doctor) => (
              <SwiperSlide key={doctor.id}>
                <Card
                  data={doctor}
                  expanded={expandedCard === doctor.id}
                  onToggleExpand={() => toggleExpand(doctor.id)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

const Card = ({ data }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${data.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="w-full h-auto flex flex-col justify-start md:pt-6 md:pb-11 items-center cursor-pointer border border-transparent font-poppins tracking-wider"
    >
      <img
        src={data.img}
        alt="doctor"
        className="w-[225px] aspect-square rounded-full object-cover"
      />
      <p className="text-xl font-bold py-2 text-center text-secondary font-poppins tracking-wider">
        {data.name.toUpperCase()}
      </p>
      <p className="text-md font-semibold text-center text-secondary font-poppins">
        {data.designation.toUpperCase()}
      </p>
      <p className="text-md font-light text-center text-secondary font-poppins">
        {data.speciality.toUpperCase()}
      </p>
      <div className="text-md p-5 text-secondary font-poppins text-center">
        {Array.isArray(data.education) && (
          <div className="line-clamp-5">
            {data.education.map((edu, index) => (
              <div key={index}>
                {edu.education1 && <p>{edu.education1}</p>}
                {edu.education2 && <p>{edu.education2}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
      <button>
        <img src={IMG.ARO} alt="arrow" className="w-[40px]" />
      </button>
    </div>
  );
};
